var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{attrs:{"scrolling":"no","width":_vm.styl.width,"height":_vm.styl.pheight,"frameBorder":"0","allowTransparency":"true","src":_vm.setSrc}})])
}
var staticRenderFns = []

export { render, staticRenderFns }